import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list_ic_prompt",
  "use": "icon-list_ic_prompt-usage",
  "viewBox": "0 0 172 41",
  "content": "<symbol viewBox=\"0 0 172 41\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-list_ic_prompt\"><path d=\"m8.7 0c-4.8 0-8.7 3.6-8.7 8v20c0 4.4 3.9 8 8.7 8h.4l5.8 5 5.8-5h142.4c4.8 0 8.7-3.6 8.7-8v-20c0-4.4-3.9-8-8.7-8z\" fill-opacity=\".7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/list_ic_prompt.svg
// module id = Fd4j
// module chunks = 87